import { z } from 'zod';

/**
 * The rejection.
 *
 * **A required free-text reason, and deliberately not a picker.** The UI/UX pack
 * rules out a rejection-reason *list* — no configured vocabulary names one, and
 * inventing one would invent configuration — while the owning service requires a
 * written reason on the wire and refuses a blank one. Both hold at once: the
 * field is free text the operator writes, and no set of canned reasons is drawn.
 *
 * **No character ceiling is declared here.** The service bounds it by its own
 * configured maximum; a number chosen in this bundle would promise a constraint
 * the service does not enforce and would drift the moment the setting moved.
 */
export const rejectFormSchema = z.object({
  reason: z.string().trim().min(1, 'اكتب سبب الرفض قبل الحسم.'),
});

export type RejectFormValues = z.infer<typeof rejectFormSchema>;
